import React from 'react';

import { PageWidgetWrapper } from 'components/common/PageWidgetWrapper/PageWidgetWrapper';

import { Tabs } from 'components/DesignSystem/Tabs';
import { ActivityLevelDrivers } from 'components/widgets/ActivityLevelDrivers/ActivityLevelDrivers';
import { DistributionGraph } from 'components/widgets/DistributionGraph/DistributionGraph';
import { RiskRegister } from 'components/widgets/RiskRegister/RiskRegister';
import { useRiskRegisterTabsLogic } from 'components/widgets/RiskRegisterTabs/RiskRegisterTabs.logic';
import classes from 'components/widgets/RiskRegisterTabs/RiskRegisterTabs.module.scss';

export const RiskRegisterTabs = () => {
    const { logic } = useRiskRegisterTabsLogic();

    return (
        <>
            <Tabs
                tabs={logic.tabsList}
                value={logic.activeTab}
                onChange={(value) => logic.setActiveTab(value as 'table' | 'chart')}
            />
            <div className={classes.container}>
                <PageWidgetWrapper>
                    <RiskRegister activeTab={logic.activeTab} />
                    <DistributionGraph activeTab={logic.activeTab} />
                    <ActivityLevelDrivers activeTab={logic.activeTab} />
                </PageWidgetWrapper>
            </div>
        </>
    );
};
